import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { FilterFormField, FilterForm } from 'src/app/models/FilterForm';
import { Item } from 'src/app/models/item';
import { AutoCompleteItem } from 'src/app/models/SelectItems';
import { LookUpService } from 'src/app/services/lookup.service';

@Component({
  selector: 'app-report-dynmic-filters',
  templateUrl: './report-dynmic-filters.component.html',
  styleUrls: ['./report-dynmic-filters.component.css']
})
export class ReportDynmicFiltersComponent {
  @Input() required_input_fields: FilterForm = {};
  @Input() questionFor: string = "";
  @Input() containerClass: string ="";
  @Input() isReadOnly: boolean =false;
  @Output() dataEvent  = new EventEmitter<any>(); 
  @Output() applyButtonEvent = new EventEmitter<any>(); 

  //AutoComplete
  @Input() pincodeList:AutoCompleteItem[] = [];
  today = new Date();
  nomineeMaxDOB = moment(this.today).add(-18, 'years').format('YYYY-MM-DD');
  maxDOB = moment(this.today).format('YYYY-MM-DD');
  selectedStartDate:any = moment(this.today).add(-7, 'days').format();
  selectedEndDate:any = this.today;
  selectedDateRange:string="Past 7 Days";
  constructor(private lookUpService:LookUpService){
    let ddd = this.required_input_fields;
    debugger;
  }
  onChange(id:string,event:any, type:any="", parentId:any =""){
    let selectedValue = type !="checkbox" ? event.target.value : (event.target.checked == true ? "Yes" : "No");
    console.log(id + '-' + selectedValue);
    event.stopPropagation();
    this.required_input_fields.filterFormFields = this.required_input_fields.filterFormFields?.map((obj:FilterFormField) => {
      if (obj.id === id) {
          return { ...obj, selectedValue: selectedValue };
      }
      return obj;
    });
    this.dataEvent.emit({data: this.required_input_fields,parentId:parentId,for:this.required_input_fields.for});
    
  }

  onPincodeSelection(id:string,data:AutoCompleteItem, type:any="", parentId:any ="")
  {
    this.required_input_fields.filterFormFields = this.required_input_fields.filterFormFields?.map((obj:FilterFormField) => {
      if (obj.id === id) {
          return { ...obj, selectedValue: data.pincodeMaster?.pincode };
      }
      else if(obj.id?.startsWith("AddressState")){
        return { ...obj, selectedValue: data.pincodeMaster?.state?.toUpperCase()??"" };
      }
      else if(obj.id?.startsWith("AddressCity")){
        return { ...obj, selectedValue: data.pincodeMaster?.district?.toUpperCase()??"" };
      }
      return obj;
    });
    this.dataEvent.emit({data: this.required_input_fields,parentId:parentId,for:this.required_input_fields.for});
 }

 onInputChange(event: any): void {
  const initialValue = event.target.value;
  const input = event.target as HTMLInputElement;
    // Strictly replace anything not a digit.
    event.target.value = initialValue.replace(/[^0-9]/g, '');
    if (input.value.length > 6) {
        input.value = input.value.slice(0, 6);
        event.stopPropagation();
      }
    if (initialValue !== event.target.value) {
      event.stopPropagation();    
    }
  }

  async onPincodeChange(data:any) {
    if(data.length >= 3){
      const res = await this.lookUpService.pincodeMasterDetails(data);
      if (res != null && res.result) {
        this.pincodeList = res.result.map((item:any)=> {return {text:item.pincode,value:item.pincode,text1: item.cityVillageArea, id:item.id,pincodeMaster:item}});
      }
    }    
  }

  onInputPhone(event: any): void {
    const initialValue = event.target.value;
    // Strictly replace anything not a digit.
    event.target.value = initialValue.replace(/[^0-9]/g, '');
    if (initialValue !== event.target.value) {
      event.stopPropagation();
    }
  }

  validateNumberInput(event: KeyboardEvent): void {
    // Allow: backspace, delete, tab, escape, enter, and numbers from the numpad and numbers row
    if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
         // Allow: Ctrl/cmd+A
        (event.keyCode === 65 && (event.ctrlKey === true || event.metaKey === true)) ||
         // Allow: Ctrl/cmd+C
        (event.keyCode === 67 && (event.ctrlKey === true || event.metaKey === true)) ||
         // Allow: Ctrl/cmd+X
        (event.keyCode === 88 && (event.ctrlKey === true || event.metaKey === true)) ||
         // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
         // let it happen, don't do anything
         return;
    }
    // Ensure that it is a number and stop the keypress if not
    if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault();
    }
  }
  
  isEmailValid(value:any):boolean{    
    return true;
  }

  applyButtonClick(){
    this.required_input_fields.filterFormFields = this.required_input_fields.filterFormFields?.map((obj:FilterFormField) => {
      if (obj.type === "dateRangePicker" && obj.selectedValue == "") {
          return { ...obj, selectedValue: moment(this.selectedStartDate).format('YYYY-MM-DD') + '::' + moment(this.selectedEndDate).format('YYYY-MM-DD')+ '::' + moment(this.selectedEndDate).format('YYYY-MM-DD') };
      }
      return obj;
    });
    this.applyButtonEvent.emit('');
  }

  async onMultiSelectChange(id:string,field:FilterFormField,selectItems: Item[]) {
    let selectedValues = "";
    if(selectItems && selectItems.length > 0){
      selectedValues = selectItems.map((item:Item) => {return item.id}).join(', ');
    }
    this.required_input_fields.filterFormFields = this.required_input_fields.filterFormFields?.map((obj:FilterFormField) => {
      if (obj.id === id) {
          return { ...obj, selectedValue: selectedValues };
      }
      return obj;
    });

    if(field.cascadeId != null && field.cascadeId != undefined && field.cascadeId != '')
    {
      if(this.required_input_fields != undefined && this.required_input_fields?.filterFormFields != undefined && this.required_input_fields?.filterFormFields?.length){
        for(let i=0;i<this.required_input_fields?.filterFormFields?.length;i++){
          let obj = this.required_input_fields?.filterFormFields[i];

          if (obj.id === field.cascadeId) {
              obj.selectedValue = "";
              obj.parentSelectedValue = selectedValues;
              obj.grandParentSelectedValue = field.parentSelectedValue;
              let options = await this.loadCascadeItems(field.cascadeId,selectedValues,field.parentSelectedValue,field.grandParentSelectedValue);
              obj.options = options??[];
          }
        }
      }
    }
    this.dataEvent.emit({data: this.required_input_fields,parentId:"",for:this.required_input_fields.for});
  }

  async onDateRangeChange(id:string,selectedValues:any) {
      if(selectedValues?.length > 0){
        let dataArray = selectedValues.split('::');
        if(dataArray?.length > 2){
          this.selectedStartDate = dataArray[0];
          this.selectedEndDate = dataArray[1];
          this.selectedDateRange = dataArray[2];
        }
      }
    this.required_input_fields.filterFormFields =  this.required_input_fields.filterFormFields?.map((obj:FilterFormField) => {
      if (obj.id === id) {
          return { ...obj, selectedValue: selectedValues };
      }
      return obj;
    });
    this.dataEvent.emit({data: this.required_input_fields,parentId:"",for:this.required_input_fields.for});
  }

  async get(data:any) {
    if(data.length >= 3){
      const res = await this.lookUpService.pincodeMasterDetails(data);
      if (res != null && res.result) {
        this.pincodeList = res.result.map((item:any)=> {return {text:item.pincode,value:item.pincode,text1: item.cityVillageArea, id:item.id,pincodeMaster:item}});
      }
    }    
  }

  onPincodeSelection2(id:string,data:AutoCompleteItem, type:any="", parentId:any ="")
  {
    this.required_input_fields.filterFormFields = this.required_input_fields.filterFormFields?.map((obj:FilterFormField) => {
      if (obj.id === id) {
          return { ...obj, selectedValue: data.pincodeMaster?.pincode };
      }
      else if(obj.id?.startsWith("AddressState")){
        return { ...obj, selectedValue: data.pincodeMaster?.state?.toUpperCase()??"" };
      }
      else if(obj.id?.startsWith("AddressCity")){
        return { ...obj, selectedValue: data.pincodeMaster?.district?.toUpperCase()??"" };
      }
      return obj;
    });
    this.dataEvent.emit({data: this.required_input_fields,parentId:parentId,for:this.required_input_fields.for});
 }

  async loadCascadeItems(id:any,selectedValue:any,parentSelectedValue:any="",grandParentSelectedValue:any="",param1:any='',param2:any='',param3:any='',param4:any='')
  {
    let item:any=[];
    let obj ={
      id:id,
      selectedValue:selectedValue,
      parentSelectedValue:parentSelectedValue,
      grandParentSelectedValue:grandParentSelectedValue,
      param1:param1,
      param2:param2,
      param3:param3,
      param4:param4,
    }

    let response = await this.lookUpService.ReportCascadeItems(obj)
    debugger;
    if (response?.isSuccess && response?.result?.length > 0) {
      item = response.result;
      if(id.toLowerCase()?.indexOf('multiselect') != -1){
        item = response.result.map((m:any)=> {return {name:m.text,value:m.value,id:m.value,checked:false}});
      }
    }
    return item;
  }
}
